import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SqueezeTube.svg",
  "use": "SqueezeTube.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SqueezeTube.svg\"><path d=\"M37.4323,44H26.5676a3,3,0,0,1-2.964-2.5369L19.1918,13.2276A15.9861,15.9861,0,0,1,19,10.7575V9.5A1.5,1.5,0,0,1,20.5,8h23A1.5,1.5,0,0,1,45,9.5v1.2575a15.9863,15.9863,0,0,1-.192,2.47L40.3965,41.4631A3,3,0,0,1,37.4323,44ZM25.5,46h13A1.5,1.5,0,0,1,40,47.5v7A1.5,1.5,0,0,1,38.5,56h-13A1.5,1.5,0,0,1,24,54.5v-7A1.5,1.5,0,0,1,25.5,46Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol